import classnames from 'classnames';
import { BiDollarCircle } from 'react-icons/bi';
import TabSection from '@features/components/CaseOverview/components/TabSection/TabSection';
import { InvoicesSectionTable } from '@features/components/CaseOverview/components/Invoices/InvoicesSectionTable';
import { Invoice } from '@/api/apis/case';
import { Uuid } from '@/api/types';

type InvoicesSectionRowProps = {
  invoices: Invoice[];
  caseId: Uuid;
};

export const InvoicesSectionRow = ({ invoices, caseId }: InvoicesSectionRowProps) => {
  const isInvoiceEmpty = invoices.length === 0;

  return (
    <TabSection title="Invoices">
      <div
        className={classnames('w-full', {
          'flex flex-col gap-3 items-center justify-center min-h-[176px]': isInvoiceEmpty,
        })}
      >
        {isInvoiceEmpty ? (
          <>
            <BiDollarCircle size={60} className="text-base-50" />
            <span className="text-l-r text-base-30">No invoices have been added</span>
          </>
        ) : (
          <InvoicesSectionTable invoices={invoices} caseId={caseId} />
        )}
      </div>
    </TabSection>
  );
};
